/**
 * Autogenerated file.
 * For adding or changing icons, see README.MD
 */
import React from 'react';
import { createIcon } from '../../icon/create-icon';
// Outline
const WrenchOutline = props => (/*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
  stroke: "var(--i-color)",
  strokeLinecap: props.strokeLinecap,
  strokeLinejoin: props.strokeLinejoin,
  strokeWidth: "var(--i-s-width)",
  d: "M20.518 6.662c.49 1.15.61 2.42.35 3.64a5.958 5.958 0 0 1-1.84 3.16c-.93.84-2.1 1.37-3.34 1.51s-2.49-.11-3.59-.72l-5.26 6.09c-.42.43-.99.66-1.59.66s-1.17-.23-1.59-.66c-.43-.42-.66-.99-.66-1.59s.23-1.17.66-1.59l6.09-5.26c-.61-1.1-.86-2.35-.72-3.59s.67-2.41 1.51-3.34c.83-.93 1.94-1.57 3.16-1.84 1.22-.26 2.5-.14 3.64.35l-3.93 3.93.53 2.65 2.65.53 3.93-3.93z"
})));
// Fill
const WrenchFill = props => (/*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
  fill: "var(--i-color)",
  d: "M19.77 13.768c-.96.96-2.19 1.6-3.53 1.86-1.33.25-2.71.1-3.96-.44l-4.87 5.64c-.01.02-.03.03-.04.04a3.008 3.008 0 0 1-2.12.88 3.008 3.008 0 0 1-3-3 3.008 3.008 0 0 1 .88-2.12l.04-.04 5.64-4.87c-.54-1.24-.7-2.61-.45-3.94.24-1.33.88-2.56 1.83-3.52a6.755 6.755 0 0 1 7.44-1.47c.12.05.22.13.29.22.08.1.13.21.15.33a.705.705 0 0 1-.2.67l-3.65 3.65.35 1.77 1.77.35 3.65-3.65a.705.705 0 0 1 .67-.2c.12.02.23.07.33.15.09.07.17.17.22.29.53 1.23.67 2.6.42 3.92a6.776 6.776 0 0 1-1.86 3.48z"
})));
// DuoTone
const WrenchDuotone = props => (/*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
  fill: "var(--i-color)",
  d: "M20.518 6.662c.49 1.15.61 2.42.35 3.64a5.958 5.958 0 0 1-1.84 3.16c-.93.84-2.1 1.37-3.34 1.51s-2.49-.11-3.59-.72l-5.26 6.09c-.42.43-.99.66-1.59.66s-1.17-.23-1.59-.66c-.43-.42-.66-.99-.66-1.59s.23-1.17.66-1.59l6.09-5.26c-.61-1.1-.86-2.35-.72-3.59s.67-2.41 1.51-3.34c.83-.93 1.94-1.57 3.16-1.84 1.22-.26 2.5-.14 3.64.35l-3.93 3.93.53 2.65 2.65.53 3.93-3.93z",
  opacity: 0.2
}), /*#__PURE__*/React.createElement("path", {
  stroke: "var(--i-color)",
  strokeLinecap: props.strokeLinecap,
  strokeLinejoin: props.strokeLinejoin,
  strokeWidth: "var(--i-s-width)",
  d: "M20.518 6.662c.49 1.15.61 2.42.35 3.64a5.958 5.958 0 0 1-1.84 3.16c-.93.84-2.1 1.37-3.34 1.51s-2.49-.11-3.59-.72l-5.26 6.09c-.42.43-.99.66-1.59.66s-1.17-.23-1.59-.66c-.43-.42-.66-.99-.66-1.59s.23-1.17.66-1.59l6.09-5.26c-.61-1.1-.86-2.35-.72-3.59s.67-2.41 1.51-3.34c.83-.93 1.94-1.57 3.16-1.84 1.22-.26 2.5-.14 3.64.35l-3.93 3.93.53 2.65 2.65.53 3.93-3.93z"
})));
/**
  Icon WrenchIcon in system group
*/
export const WrenchIcon = createIcon('WrenchIcon', 'wrench', 'system', WrenchOutline, WrenchFill, WrenchDuotone, "0 0 24 24");